var _path, _path2, _circle, _circle2, _circle3, _path3, _path4, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 103,
    viewBox: "0 0 140 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105 100.7L20.0003 100.7C9.12033 100.7 0.300361 91.88 0.30036 81L0.300356 15.0429L124.7 15.0429L124.7 81C124.7 91.88 115.88 100.7 105 100.7Z",
    fill: "white",
    stroke: "#D2DBE2",
    strokeWidth: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0818 0.3L108.918 0.3C117.534 0.3 124.537 7.20421 124.697 15.7818L0.302794 15.7818C0.462709 7.20421 7.46598 0.3 16.0818 0.3Z",
    fill: "#EBF2F9",
    stroke: "#D2DBE2",
    strokeWidth: 0.6
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.9645,
    cy: 8.04088,
    r: 1.89298,
    fill: "#EBF2F9",
    stroke: "#D2DBE2",
    strokeWidth: 0.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.275,
    cy: 8.04088,
    r: 1.89298,
    fill: "#EBF2F9",
    stroke: "#D2DBE2",
    strokeWidth: 0.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5846,
    cy: 8.04088,
    r: 1.89298,
    fill: "#EBF2F9",
    stroke: "#D2DBE2",
    strokeWidth: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0977 78.5H49.9023C48.0945 78.5 46.623 77.0285 46.623 75.2207V39.7793C46.623 37.9715 48.0945 36.5 49.9023 36.5H65.7793V44.8184C65.7793 47.1785 67.6985 49.0977 70.0586 49.0977H78.377V75.2207C78.377 77.0285 76.9055 78.5 75.0977 78.5ZM70.0586 53.2207H54.9414C53.9689 53.2207 53.1816 54.008 53.1816 54.9805C53.1816 55.9529 53.9689 56.7402 54.9414 56.7402H70.0586C71.031 56.7402 71.8184 55.9529 71.8184 54.9805C71.8184 54.008 71.031 53.2207 70.0586 53.2207ZM70.0586 58.2598H54.9414C53.9689 58.2598 53.1816 59.0471 53.1816 60.0195C53.1816 60.992 53.9689 61.7793 54.9414 61.7793H70.0586C71.031 61.7793 71.8184 60.992 71.8184 60.0195C71.8184 59.0471 71.031 58.2598 70.0586 58.2598ZM70.0586 63.2988H54.9414C53.9689 63.2988 53.1816 64.0861 53.1816 65.0586C53.1816 66.031 53.9689 66.8184 54.9414 66.8184H70.0586C71.031 66.8184 71.8184 66.031 71.8184 65.0586C71.8184 64.0861 71.031 63.2988 70.0586 63.2988ZM65.0195 68.3379H54.9414C53.9689 68.3379 53.1816 69.1252 53.1816 70.0977C53.1816 71.0701 53.9689 71.8574 54.9414 71.8574H65.0195C65.992 71.8574 66.7793 71.0701 66.7793 70.0977C66.7793 69.1252 65.992 68.3379 65.0195 68.3379Z",
    fill: "#EBF2F9",
    stroke: "#D2DBE2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9317 45.578H70.0586C69.6397 45.578 69.2988 45.2372 69.2988 44.8183V37.9451L76.9317 45.578Z",
    fill: "#EBF2F9",
    stroke: "#D2DBE2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2940_2764)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.239 73C117.387 73 111 79.6294 111 87.7788C111 95.9281 117.387 102.558 125.239 102.558C133.091 102.558 139.478 95.9281 139.478 87.7788C139.478 79.6294 133.091 73 125.239 73Z",
    fill: "#EBF2F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.239 102.558C117.387 102.558 111 95.9281 111 87.7788C111 79.6294 117.387 73 125.239 73C133.091 73 139.478 79.6294 139.478 87.7788C139.478 95.9281 133.091 102.558 125.239 102.558ZM125.239 74.8473C118.369 74.8473 112.78 80.648 112.78 87.7788C112.78 94.9095 118.369 100.71 125.239 100.71C132.109 100.71 137.698 94.9095 137.698 87.7788C137.698 80.648 132.109 74.8473 125.239 74.8473Z",
    fill: "#D2DBE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.468 88.7026H119.009C118.518 88.7026 118.119 88.2888 118.119 87.7789C118.119 87.269 118.518 86.8552 119.009 86.8552H131.468C131.96 86.8552 132.358 87.269 132.358 87.7789C132.358 88.2888 131.96 88.7026 131.468 88.7026Z",
    fill: "#D2DBE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.24 95.1682C124.748 95.1682 124.35 94.7544 124.35 94.2445V81.3131C124.35 80.8032 124.748 80.3894 125.24 80.3894C125.731 80.3894 126.13 80.8032 126.13 81.3131V94.2445C126.13 94.7544 125.731 95.1682 125.24 95.1682Z",
    fill: "#D2DBE2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2940_2764"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.4783,
    height: 29.5576,
    fill: "white",
    transform: "translate(111 73)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.0a45148a4651a7fddd0f54be8109437c.svg";
export { ForwardRef as ReactComponent };